import { useEffect, useState } from "react";
import Checkbox from "../../../../Components/Checkbox/Checkbox";
import { useTranslation } from 'react-i18next';
import InputText from "../../../../Components/InputText/InputText";
import Spinner from "../../../../Components/Spinner/Spinner";

const AddAgent = (props: any) => {
	const [users, setUsers] = useState<Array<any>>(props.users);
	const [searchInput, setSearchInput] = useState('');
	const [checked, setIsChecked] = useState<{[key: string]: boolean}>({});
	const { t } = useTranslation();

	useEffect(() => {
		setUsers(props.users.filter((u:any) => {
			return (`${u.name} ${u.surname} (${u.extension})`).toLowerCase().includes(searchInput)
		}));

		users.forEach((u:any) => {
			u.added = false

			props.members.forEach((m:any) => {
				if(m.props.member.pbx_user_id === u.id) {
					u.added = true
				}
			});
		});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ searchInput ])

	useEffect(() => {
		props.onCheckedChanged(checked)
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ checked ])

	const searchUser = (searchValue:any) => {
		setSearchInput(searchValue.toLowerCase());
	}

	const toggleMarkedAll = (isChecked: boolean) => {
		if(!isChecked) {
			setIsChecked({});
			return
		}

		const a: {[key: string]: boolean} = {};

		props.users.forEach((u: any) => a[u.id] = true)

		setIsChecked(a);
	}

	if(props.loading) {
		return <div className="add-agent">
			<div className="small-12 columns search-container">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

	return <div className="add-agent">
		<div className="small-12 columns search-container">
			<InputText
				className="search"
				placeholder={t('search')}
				value={searchInput}
				onChange={(event:any) => {
					searchUser(event.target.value);
				}}
			/>

		</div>
		<div className="row">
			<div className="small-12 columns select-multiple-users">
				<label>
					<div className="small-2 columns">
						<Checkbox
							id='mark-all'
							name='mark-all'
							onChange={(isChecked: boolean) => {
								toggleMarkedAll(isChecked);
							}}
						/>
					</div>
					<div className="small-10 columns">
						<span><b>{t('mark_all')}</b></span>
					</div>
				</label>
			</div>
			{
				props.members.length !== 0 ?
					users.map((user:any) => {
						return <div
							key={user.id}
							className="small-12 columns select-multiple-users"
						>
							<label>
								<div className="small-2 columns">
									<Checkbox
										id={user.id}
										name={user.id}
										checked={
											user.added && user.added === true ? true : !!checked[user.id]
										}
										disabled={user.added && user.added === true ? true : false}
										controlled={true}
										onClick={(isCheck: boolean) => {
											const a = JSON.parse(JSON.stringify(checked))
											a[user.id] = isCheck
											setIsChecked(a)
										}}
									/>
								</div>
								<div className="small-10 columns">
									<span>{ `${user.name} ${user.surname} (${user.extension})` }</span>
								</div>
							</label>
						</div>
					})
				:
				<div className="small-12 columns">
					<span className="center">{t('no_data_found')}</span>
				</div>
			}
		</div>
	</div>
}

export default AddAgent;
